import { useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AddTestWizardPage from 'shared/components/AddTestWizard/AddTestWizardPage';
import { EditWizardState } from 'shared/components/AddTestWizard/types';
import useUrlWithEnv from 'shared/hooks/useUrlWithEnv';
import { isWizardResourceType } from 'testManagement/utils/utils';

const isEditWizardState = (state: unknown): state is EditWizardState => {
  if (!state || typeof state !== 'object') return false;
  const candidate = state as EditWizardState;
  return (
    isWizardResourceType(candidate.wizardResourceType) &&
    !!candidate.initialValues &&
    !!candidate.editTestMetadata
  );
};

const EditTestWizardRoute = () => {
  const { state } = useLocation();
  const getUrlWithEnv = useUrlWithEnv();

  const editStateRef = useRef<EditWizardState | null>(null);
  if (isEditWizardState(state)) {
    editStateRef.current = state;
  } else if (state != null) {
    editStateRef.current = null;
  }

  const editState = editStateRef.current;
  if (!editState) {
    return <Navigate to={getUrlWithEnv('/test-management')} replace />;
  }

  return <AddTestWizardPage wizardMode="edit" {...editState} />;
};

export default EditTestWizardRoute;
